import _ from 'underscore';
import Bowser2 from 'bowser';
import Util from 'root/module/util';
import View from 'view/base';

var Browser_View = View.extend({
    browsers_to_display: ['Chrome', 'Chromium', 'Firefox', 'Safari', 'Opera', 'Microsoft Edge', 'Internet Explorer'],

    events: {
        'click .view-more': 'viewMore'
    },

    dom_handlers: {
        viewMore: function(e) {
            e.preventDefault();

            this.$el.find('tr').show();
            this.$el.find('.view-more').parents('tr:first').remove();
        }
    },

    initialize: function(chart_data) {
        this.browser_stats = {};

        _.each(chart_data, function(count, user_agent) {
            var browser  = Bowser2.getParser(user_agent);
            var os_icon = '';
            var browser_icon = '';

            var browser_name = browser.getBrowserName();
            var os_name = browser.getOSName();

            if (os_name === 'Android') {
                os_icon = 'fab fa-android';
            } else if (os_name === 'iOS') {
                os_icon = 'fab fa-apple';
            } else if (os_name == 'Windows') {
                os_icon = 'fab fa-windows';
            } else if (os_name == 'macOS') {
                os_icon = 'fab fa-apple';
            } else {
                os_name = 'Other';
                os_icon = 'far fa-question-circle';
            }

            switch (browser_name) {
                case 'Chrome':
                case 'Chromium':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/chrome_logo.png">';
                    break;
                case 'Firefox':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/firefox_logo.png">';
                    break;
                case 'Safari':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/safari_logo.png">';
                    break;
                case 'Microsoft Edge':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/edge_logo.png">';
                    break;
                case 'Internet Explorer':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/ie_logo.png">';
                    break;
                case 'Opera':
                    browser_icon = '<img style="width:14px;height:14px;margin:2px 6px 0 0;" class="browser-meta-logo float-left" src="/image/opera_logo.png">';
                    break;
                default:
                    browser_icon = '<i class="text-info fas fa-question-circle"></i>';
                    break;
            }

            if (this.browsers_to_display.indexOf(browser_name) === -1) {
                browser_name = 'Unknown';
                os_name = 'Unknown';
                os_icon = 'fas fa-question-circle';
            }

            var browser_key = browser_name + os_name;

            if (this.browser_stats[browser_key] !== undefined) {
                this.browser_stats[browser_key]['count'] += count;
            } else {
                this.browser_stats[browser_key] = {
                    name: browser_name,
                    count: count,
                    os_name: os_name,
                    os_icon: os_icon,
                    browser_icon: browser_icon
                };
            }
        }, this);

        // convert object to array and sort it
        this.browser_stats_sorted = [];
        _.each(this.browser_stats, function(data, index) {
            this.browser_stats_sorted.push(data);
        }, this);

        this.browser_stats_sorted.sort(function(a, b) {
            if (a.count > b.count) {
                return -1;
            } else if (a.count < b.count) {
                return 1;
            } else {
                if (a.name == b.name) {
                    return a.os_name > b.os_name ? 1 : -1;
                } else {
                    return a.name > b.name ? 1 : -1;
                }
            }
        });
    },

    render: function() {
        var html = '';

        html += '<table class="medium">' +
                '<tr>' +
                    '<th>Browser</th>' +
                    '<th>Operating System</th>' +
                    '<th width="50%">Feedback</th>' +
                '</tr>';

        var min_row = 5;
        var total = 0;

        _.each(this.browser_stats_sorted, function(data, index) {
            total += data.count;
        });

        _.each(this.browser_stats_sorted, function(data, index) {
            var percentage = 0;

            if (total) {
                percentage = data.count / total * 100;
            }

            html += '<tr' + (index >= min_row ? ' style="display:none;"' : '') + '>' +
                        '<td>' + data.browser_icon + ' ' + Util.htmlEntities(data.name) + '</td>' +
                        '<td><i class="info fa-fw ' + data.os_icon + '"></i> ' + Util.htmlEntities(data.os_name) + '</td>' +
                        '<td><div class="meteor-primary margin-bottom-4"><div><span style="width:' + percentage + '%;"></span></div></div>' + data.count + '</td>' +
                    '</tr>';

            index++;
        });

        if (this.browser_stats_sorted.length < min_row) {
            for (var i = 0; i < min_row - this.browser_stats_sorted.length; i++) {
                html += '<tr class="empty"><td colspan="3" height="67"></td></tr>';
            }
        }

        if (this.browser_stats_sorted.length > min_row) {
            html += '<tr class="empty"><td colspan="3" align="right"><a href="#" class="primary view-more"><b>View More</b></a></td></tr>';
        }

        html += '</table>';

        this.$el.html(html);
        return this;
    }
});

export default Browser_View;